/**
 * Created by apokdev on 6/6/17.
 */
import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import jQuery from 'jquery';

let $ = window.$ = window.jQuery = jQuery;

export default class extends Component{
    constructor(props) {
        super(props)
        this.state = {
            region: "",
            poi: {
                tipo: {nombre: ""},
                pois: []
            }
        }
    }
    componentDidUpdate(prevProps) {
        if (prevProps.poi !== this.props.poi) {
            this.updateState();
        }
    }
    componentDidMount() {
        this.updateState();
        this.slick(true);
    }
    updateState() {
        this.setState({
            poi: this.props.poi,
            region: this.props.region
        })
    }
    slick(firstRun) {
        if (!firstRun) {
            $(".lista-pois-slick").slick("unslick");
        }
        let isVertical = this.props.vertical;
        let prevArrowClass = (isVertical) ? "up" : "left";
        let nextArrowClass = (isVertical) ? "down" : "right";

        let responsiveOptions = {};
        if(!isVertical){
            responsiveOptions = [
                {
                    breakpoint: 1920,
                    settings: {
                        slidesToShow: 5,
                        slidesToScroll: 5,
                    }
                },
                {
                    breakpoint: 1280,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 4,
                    }
                },
                {
                    breakpoint: 769,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3
                    }
                }
            ];
        }

        setTimeout(() => {
            $(`#${this.props.id}`).slick({
                infinite: true,
                responsive: responsiveOptions,
                respondTo: 'min',
                slidesToShow: this.props.slides || 3,
                slidesToScroll: this.props.slides || 3,
                vertical: this.props.vertical || false,
                verticalSwiping: this.props.vertical || false,
                prevArrow: `<button type="button" class="slick-nav-control slick-prev slick-${prevArrowClass}"></button>`,
                nextArrow: `<button type="button" class="slick-nav-control slick-next slick-${nextArrowClass}"</button>`
            });
            $(`#${this.props.id}`).on('setPosition',(event,slick,currentSlide,nextSlide) => {
                //console.log(slick,this.props.id,"setPosition");
                if(slick.$slides.length === 1){
                    $(`#${this.props.id}`).css("height","300px");
                }
            });
        });
    }
    render() {
        let poi = this.state.poi;
        let containerClassName = `contenedor-pois-slick${((this.props.vertical) ? "-vertical" : "")} ${this.state.region}`;
        //let containerClassName = "contenedor-pois-slick" + ((this.props.vertical) ? "-vertical" : "") + " " + this.state.region;
        return (
            <div className={containerClassName}>
                <h3 style={this.props.tituloClass || {}}>{this.props.titulo || poi.tipo.nombre}</h3>
                <div id={this.props.id}
                     className={"lista-pois-slick slick-" + ((this.props.vertical) ? "vertical" : "horizontal") + " " + this.state.region}>
                    {
                        poi.pois.map((poi) => {
                            let imagen = '/img/brujula_oficial_gris.png';
                            if (poi.imagenes && poi.imagenes.length) {
                                imagen = poi.imagenes[0].thumbnail;
                            }
                            return (
                                <div key={poi.id} className="poi-slick-item">
                                    <Link to={`/poi/${poi.slug}`}>
                                        <img src={imagen} alt=""/>
                                        <h4>{poi.nombre}</h4>
                                    </Link>
                                </div>
                            )
                        })
                    }
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/SlickPoi.js